module.exports = __webpack_public_path__ + "static/media/Specialty-Business-Unit.9b859a32.jpg";